import { render, staticRenderFns } from "./CustomerNetMatchVolunteer.vue?vue&type=template&id=ddc0dc14"
import script from "./CustomerNetMatchVolunteer.vue?vue&type=script&lang=ts"
export * from "./CustomerNetMatchVolunteer.vue?vue&type=script&lang=ts"
import style0 from "./CustomerNetMatchVolunteer.vue?vue&type=style&index=0&id=ddc0dc14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports